module.exports = __webpack_public_path__ + "img/account_clipboard.8b77ce04.svg";